export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-gray-300 py-16 text-sm">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h2 className="text-2xl text-white font-black mb-6">
              KR<span className="text-teal-400">STUDIO</span>
            </h2>
            <p className="leading-relaxed">성공 비즈니스를 위한 최적의 파트너</p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold mb-6">Services</h3>
            <ul className="space-y-3">
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/content-production">콘텐츠 제작</a>
              </li>
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/live-streaming">라이브 스트리밍</a>
              </li>
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/on-site-service">현장 촬영 서비스</a>
              </li>
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/studio-consulting">스튜디오 컨설팅</a>
              </li>
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/ai-content">AI 콘텐츠</a>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-white font-bold mb-6">Solutions</h3>
            <ul className="space-y-3">
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/integrated-solution">통합 솔루션</a>
              </li>
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/university-solution">대학 솔루션</a>
              </li>
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/public-solution">공공기관 솔루션</a>
              </li>
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/enterprise-solution">기업 솔루션</a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-bold mb-6">Company</h3>
            <ul className="space-y-3">
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/kr-story">KR Story</a>
              </li>
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/portfolio">포트폴리오</a>
              </li>
              <li className="hover:text-teal-400 transition cursor-pointer">
                <a href="/news">뉴스&소식</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-700 pt-8 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-xs">
            <div className="flex items-start">
              <i className="ri-map-pin-line mr-2 mt-0.5 text-teal-400"></i>
              <span>서울시 서초구 서초대로56길 40, 3층</span>
            </div>
            <div className="flex items-center">
              <i className="ri-phone-line mr-2 text-teal-400"></i>
              <a href="tel:070-8656-8134" className="hover:text-teal-400 transition">070-8656-8134</a>
            </div>
            <div className="flex items-center">
              <i className="ri-mail-line mr-2 text-teal-400"></i>
              <a href="mailto:kr.kimminkyu@gmail.com" className="hover:text-teal-400 transition">kr.kimminkyu@gmail.com</a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 pt-8 text-center text-xs text-gray-400">
          <p>Copyright(c) KR Corp. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
